import genericWidgetEditor from '@components/mixins/genericWidgetEditor'
import ContentItemEditorContainer from '@components/Widgets/_contentItems/_contentItemEditorContainer.vue'

export default {
  name: 'TwoColumnWidgetEditor',
  mixins: [genericWidgetEditor],
  components: {
    'content-item-editor-container': ContentItemEditorContainer,
  },
}
